export default __webpack_public_path__ + "static/media/i166hp.04c0fefe.webp";